// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bubble {
  border-radius: 1rem;
  padding: 6px 12px;
  margin: 0 1rem;
  background-color: white;
  display: flex;
  flex-direction: column;
  max-width: 255px;
  -webkit-user-select: none;
          user-select: none;
}
@media all and (min-width: 1280px) {
  .bubble {
    max-width: 560px;
    margin: 0 1.5rem;
  }
}
.bubble--ai {
  border-bottom-left-radius: 0;
  align-self: flex-start;
  background-color: #fbfbfb;
}
.bubble--user {
  border-bottom-right-radius: 0;
  align-self: flex-end;
  background-color: #A1C7FF;
}
.bubble__message {
  flex-grow: 1;
  word-break: break-word;
  color: #151515;
}
.bubble__time {
  display: flex;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/components/Bubble/Bubble.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;AADF;AAGE;EAVF;IAWI,gBAAA;IACA,gBAAA;EAAF;AACF;AAEE;EACE,4BAAA;EACA,sBAAA;EACA,yBCaQ;ADbZ;AAGE;EACE,6BAAA;EACA,oBAAA;EACA,yBCfc;ADclB;AAIE;EACE,YAAA;EACA,sBAAA;EACA,cCLQ;ADGZ;AAKE;EACE,aAAA;EACA,yBAAA;AAHJ","sourcesContent":["@import 'src/styles/variables';\n\n.bubble {\n  border-radius: 1rem;\n  padding: 6px 12px;\n  margin: 0 1rem;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  max-width: 255px;\n  user-select: none;\n\n  @media all and (min-width: $desktop) {\n    max-width: 560px;\n    margin: 0 1.5rem;\n  }\n\n  &--ai {\n    border-bottom-left-radius: 0;\n    align-self: flex-start;\n    background-color: $white-100;\n  }\n\n  &--user {\n    border-bottom-right-radius: 0;\n    align-self: flex-end;\n    background-color: $main-light-blue;\n  }\n\n  &__message {\n    flex-grow: 1;\n    word-break: break-word;\n    color: $black-100;\n  }\n\n  &__time {\n    display: flex;\n    justify-content: flex-end;\n  }\n}","$headerHeightMobile: 60px;\n$headerHeightDesktop: 80px;\n\n$desktop: 1280px;\n\n\n// accents\n$main-blue-gradient: #100;\n$main-dark-blue: #1F106D;\n$main-mid-blue-100: #1F48B1FF;\n$main-mid-blue-50: #1F48B180;\n$main-light-blue: #A1C7FF;\n$hover-main-blue: #331CAA;\n$pressed-main-blue: #011C5A;\n$progress-bar-red: #D62B1F;\n$progress-dot-disabled: #D9D9D9;\n\n// brands\n$alfa-bank: #EF3124;\n$vsk: #4544EE;\n$h: #2078FE;\n$vtb: #002882;\n$robo-finance: #00BF6E;\n$x-5: #5FAF2D;\n$sport-master: #1551E5;\n\n// black\n$black-100: #151515FF;\n$black-75: #151515BF;\n$black-50: #15151580;\n$black-25: #15151540;\n\n// white\n$white-100: #FBFBFBFF;\n$white-75: #FBFBFBBF;\n$white-50: #FBFBFB80;\n$white-25: #FBFBFB40;\n\n// input\n$input-background: #F1F5F9;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
